<template>
  <div
    class="squircle-lg rounded border p-3 text-left"
    :class="[
      selected ? 'border-primary shadow' : '',
      disabled ? 'cursor-not-allowed bg-gray-200 opacity-50' : 'cursor-pointer'
    ]"
  >
    <div class="flex flex-row items-center">
      <h3 class="flex flex-1 leading-tight font-semibold">
        {{ supplierName }}
      </h3>
      <span
        :data-tint="supplierOrderStatus?.color"
        class="bg-primary text-contrast-primary text-xxs shrink-0 rounded-md px-1 py-0.5"
      >
        {{ supplierOrderStatus?.name ?? $t('global.to_be_validated') }}
      </span>
    </div>

    <div class="flex text-xs">
      <p>
        <FontAwesomeIcon :icon="['fal', 'location-dot']" class="w-6" />
      </p>
      <p class="capitalize-first ml-1 text-slate-500">
        {{
          supplierOrder.delivery_place?.full_name ??
          supplierOrder.delivery_place_other ??
          $t('global.n_a')
        }}
      </p>
    </div>
    <div class="font-medium text-gray-500 select-none">
      <FontAwesomeIcon :icon="['fal', 'truck-clock']" class="ml-1 w-4" />
      <span class="ml-2 text-xs font-light text-slate-500">
        {{
          supplierOrder.delivery_date_time
            ? $h.formatDate(
                supplierOrder.delivery_date_time,
                'DD/MM/YYYY HH:mm',
                $i18n.locale.substring(0, 2)
              )
            : $t('global.n_a')
        }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'StockSelectSupplierOrder',
  components: { FontAwesomeIcon },
  props: {
    supplierOrder: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      suppliers: 'metadata/getSuppliersMetadata',
      supplier_order_statuses: 'metadata/getMetadataSupplierOrderStatuses'
    }),
    supplierOrderStatus() {
      return (
        this.supplier_order_statuses.find(
          (status) => status.id === this.supplierOrder.status
        ) ?? null
      )
    },
    supplierName() {
      return (
        this.suppliers?.find(
          (supplier) => supplier.id === this.supplierOrder.recipient_id
        )?.name ?? 'undefined'
      )
    }
  }
})
</script>

<style scoped></style>
